import { Button } from '@perch-labs/shrike';
import secureLockDark from 'static/secure-lock-dark.svg';
import { ErrorMessage } from '~/components/error-message';
import { Link } from '~/components/link';
import { IS_PERCH_ENERGY } from '~/utils/constants';
import { amerenRedirectUrl } from '~/utils/redirects';
import { StyledIcon } from '../image/image.style';

export const AmerenSignup = ({ error }: { error?: string }) => {
  return (
    <>
      <ErrorMessage error={error} mb={2} />
      {IS_PERCH_ENERGY ? (
        <Button
          fullWidth
          mode="primary"
          data-testid="ameren-oauth-button"
          onClick={() => window.open(amerenRedirectUrl(), '_blank')}
        >
          <StyledIcon src={secureLockDark} data-testid="credential-secure-icon" />
          Authorize with Ameren
        </Button>
      ) : (
        <Link color="primaryInverse" fullWidth hideIcon href={amerenRedirectUrl()} type="CTA">
          Authorize with Ameren
        </Link>
      )}
    </>
  );
};
